import React from 'react';
import { FormattedMessage } from 'react-intl';
import { OptionFormTypes } from '../../../../services/filtering/filter-form-render-service/option-form-types';
import { renderFormBasedOnType } from '../../../../services/filtering/filter-form-render-service/';
import { messages } from './messages';

export const OrderTotal = {
  id: 'orderTotal',
  type: OptionFormTypes.TYPE_CURRENCY_COMPARISON,
  filterValue: 'OrderTotal',
  displayName: <FormattedMessage {...messages.orderTotal} />,

  render: (criteriaInformations) => {
    return renderFormBasedOnType(OptionFormTypes.TYPE_CURRENCY_COMPARISON, criteriaInformations);
  },
};
